import styled from "styled-components";
import media from "constants/media";
import Title from "components/shared/hero/title/Title";

export const Content = styled.div`
    margin: 30px 0 50px;

    ${media.mdUp`
        margin: 0 0 320px;
    `}
`;

export const Heading = styled(Title)`
    margin-bottom: 20px;

    ${media.mdUp`
        margin-bottom: 14px;
    `}
`;
